
export const services = [
  {
    id: 'data-analytics',
    icon: 'ri-bar-chart-box-line',
    title: '數據分析與預測',
    subtitle: 'Data Analytics & Prediction',
    description: '運用先進AI技術深度分析企業數據，建立精準預測模型，協助企業洞察市場趨勢、優化決策流程，實現數據驅動的智慧經營。',
    features: ['即時數據儀表板', '預測性分析模型', '市場趨勢洞察'],
    color: 'from-teal-500 to-emerald-500',
    bgColor: 'bg-teal-50',
    borderColor: 'border-teal-100',
    textColor: 'text-teal-600',
  },
  {
    id: 'custom-tools',
    icon: 'ri-tools-line',
    title: '客製化微型工具',
    subtitle: 'Customized Micro Tools',
    description: '根據企業獨特需求量身打造專屬數位工具，從流程自動化到智慧表單，精準解決企業痛點，大幅提升工作效率與員工體驗。',
    features: ['需求深度訪談', '快速原型開發', '完整技術支援'],
    color: 'from-orange-500 to-amber-500',
    bgColor: 'bg-orange-50',
    borderColor: 'border-orange-100',
    textColor: 'text-orange-600',
  },
  {
    id: 'ai-automation',
    icon: 'ri-robot-line',
    title: 'AI自動化工具設計',
    subtitle: 'AI Automation Design',
    description: '設計並實施全方位AI自動化解決方案，整合AI虛擬人、短影音與自媒體自動化技術，大幅減少人工作業、降低錯誤率，釋放人力專注高價值工作。',
    features: ['AI虛擬人自動化流程', '短影音自動化流程', '自媒體自動化流程'],
    color: 'from-violet-500 to-purple-500',
    bgColor: 'bg-violet-50',
    borderColor: 'border-violet-100',
    textColor: 'text-violet-600',
  },
];

export const stats = [
  { value: '150+', label: '服務企業數', icon: 'ri-building-line' },
  { value: '98%', label: '客戶滿意度', icon: 'ri-star-line' },
  { value: '40%', label: '平均效率提升', icon: 'ri-rocket-line' },
  { value: '5年+', label: '產業深耕經驗', icon: 'ri-award-line' },
];

export const caseStudies = [
  {
    id: 1,
    industry: '製造業',
    company: '台灣精密機械股份有限公司',
    challenge: '生產線數據分散、品質異常難以即時偵測，導致良率偏低。',
    solution: '導入AI視覺檢測系統與即時數據分析平台，建立預測性維護模型。',
    result: '良率提升23%，設備停機時間減少65%，年節省成本超過800萬元。',
    icon: 'ri-settings-3-line',
    color: 'from-teal-500 to-emerald-500',
    image: 'https://public.readdy.ai/ai/img_res/75ec92228cbbb5f405a77c3253fcc2b6.jpg',
  },
  {
    id: 2,
    industry: '金融服務',
    company: '聯合信用管理顧問公司',
    challenge: '信用審核流程耗時、人工審核標準不一致，客戶等待時間過長。',
    solution: '建置AI信用評分模型與自動化審核流程，整合多元數據來源。',
    result: '審核時間從3天縮短至2小時，準確率提升31%，客戶滿意度大幅提升。',
    icon: 'ri-bank-line',
    color: 'from-orange-500 to-amber-500',
    image: 'https://readdy.ai/api/search-image?query=modern%20financial%20office%20with%20multiple%20screens%20showing%20data%20charts%20graphs%20analytics%20dashboards%20professional%20business%20environment%20with%20warm%20lighting%20clean%20minimalist%20design%20financial%20technology%20fintech%20workspace%20with%20amber%20accent%20lighting&width=600&height=400&seq=case-finance-001&orientation=landscape',
  },
  {
    id: 3,
    industry: '零售電商',
    company: '全通零售集團',
    challenge: '庫存管理混亂、需求預測不準確，導致缺貨與滯銷並存。',
    solution: '開發AI需求預測引擎與智慧補貨系統，整合線上線下銷售數據。',
    result: '庫存周轉率提升45%，缺貨率降低78%，整體營收成長18%。',
    icon: 'ri-store-line',
    color: 'from-violet-500 to-purple-500',
    image: 'https://readdy.ai/api/search-image?query=modern%20retail%20warehouse%20with%20automated%20inventory%20management%20system%20robotic%20sorting%20conveyor%20belts%20digital%20screens%20showing%20stock%20levels%20and%20analytics%20clean%20organized%20storage%20facility%20with%20violet%20purple%20accent%20lighting%20smart%20logistics%20technology&width=600&height=400&seq=case-retail-001&orientation=landscape',
  },
];

export const testimonials = [
  {
    id: 1,
    name: '陳志明',
    title: '營運長',
    company: '台灣精密機械股份有限公司',
    content: '恩誠國際的AI解決方案徹底改變了我們的生產模式。從數據分析到自動化部署，團隊專業且高效，讓我們在競爭激烈的市場中取得顯著優勢。',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20middle%20aged%20taiwanese%20man%20business%20executive%20confident%20smile%20wearing%20dark%20suit%20white%20shirt%20clean%20minimal%20studio%20background%20corporate%20photography&width=100&height=100&seq=testimonial-chen-001&orientation=squarish',
    rating: 5,
  },
  {
    id: 2,
    name: '林雅婷',
    title: '數位轉型總監',
    company: '聯合信用管理顧問公司',
    content: '與恩誠合作是我們公司最正確的決策之一。他們不只是技術供應商，更是真正理解我們業務需求的策略夥伴，交付的成果遠超預期。',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20taiwanese%20woman%20business%20director%20confident%20warm%20smile%20wearing%20professional%20blazer%20clean%20minimal%20studio%20background%20corporate%20photography&width=100&height=100&seq=testimonial-lin-001&orientation=squarish',
    rating: 5,
  },
  {
    id: 3,
    name: '王建國',
    title: '執行副總裁',
    company: '全通零售集團',
    content: '導入恩誠的AI預測系統後，我們的庫存管理效率大幅提升。系統穩定可靠，技術支援團隊反應迅速，是值得長期合作的優質夥伴。',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20taiwanese%20man%20senior%20executive%20vice%20president%20confident%20expression%20wearing%20business%20suit%20clean%20minimal%20studio%20background%20corporate%20photography&width=100&height=100&seq=testimonial-wang-001&orientation=squarish',
    rating: 5,
  },
];

export const processSteps = [
  {
    step: '01',
    title: '需求診斷',
    description: '深入了解企業現況、痛點與目標，進行全面的數位化成熟度評估。',
    icon: 'ri-search-eye-line',
  },
  {
    step: '02',
    title: '方案規劃',
    description: '根據診斷結果，量身設計最適合的AI轉型路徑與實施計畫。',
    icon: 'ri-draft-line',
  },
  {
    step: '03',
    title: '敏捷開發',
    description: '採用敏捷開發方法，快速迭代交付，確保方案符合實際需求。',
    icon: 'ri-code-s-slash-line',
  },
  {
    step: '04',
    title: '部署上線',
    description: '專業團隊協助系統整合與部署，確保平穩過渡與員工培訓。',
    icon: 'ri-rocket-2-line',
  },
  {
    step: '05',
    title: '持續優化',
    description: '長期監控系統效能，持續優化模型與流程，確保最大化投資回報。',
    icon: 'ri-line-chart-line',
  },
];
